<template>
  <div>
    <el-dialog title="查看明细" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
      :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
      style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose" v-el-drag-dialog
      v-el-dialog-center>

      <!-- 品牌信息 -->
      <p>
        <vxe-radio-group v-model="selectTab" @change="changeTableDetails">
          <vxe-radio-button label="tab1" content="工单明细"></vxe-radio-button>
          <vxe-radio-button label="tab2" content="考核单明细"></vxe-radio-button>
          <vxe-radio-button label="tab4" content="费用申请单明细"></vxe-radio-button>
          <vxe-radio-button label="tab3" content="调整单明细"></vxe-radio-button>
          <vxe-radio-button label="tab7" content="销售奖励"></vxe-radio-button>
          <vxe-radio-button label="tab8" content="销售奖励调整明细"></vxe-radio-button>
          <vxe-radio-button label="tab9" content="权益核销"></vxe-radio-button>
          <vxe-radio-button label="tab10" content="激励费用单明细"></vxe-radio-button>
          <vxe-radio-button label="tab11" content="奖惩费用单明细"></vxe-radio-button>
        </vxe-radio-group>
      </p>

      <div v-show="selectTab === 'tab1'">
        <vxe-table border :stripe="true"  ref="table-m1"
          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
          :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
          height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.soOrderDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="settleNo" title="结算单号" width="120"></vxe-column>
          <vxe-column field="orderNo" title="工单号" width="120"></vxe-column>
          <vxe-column field="bigSiteCode" title="一级服务商编码" width="150"></vxe-column>
          <vxe-column field="bigSiteName" title="一级服务商名称" width="150"></vxe-column>
          <vxe-column field="orgName" title="服务经销商省" width="120"></vxe-column>
          <vxe-column field="siteTypeName" title="服务商类型" width="120"></vxe-column>
          <vxe-column field="siteCode" title="执行服务商编码" width="150"></vxe-column>
          <vxe-column field="siteName" title="执行服务商名称" width="150"></vxe-column>
          <vxe-column field="bigCategoryName" title="产品大类" width="120"></vxe-column>
          <vxe-column field="itemModel" title="产品型号" width="120"></vxe-column>
          <vxe-column field="inCode" title="条形码" width="150"></vxe-column>
          <vxe-column field="itemCode" title="客制物料编码" width="150"></vxe-column>
          <vxe-column field="itemName" title="客制物料名称" width="150"></vxe-column>
          <vxe-column field="guaranteeType" title="维修性质" width="90"></vxe-column>
          <vxe-column field="orderTypeName" title="工单来源" width="120"></vxe-column>
          <vxe-column field="recallDate" title="回访时间" width="150"></vxe-column>
          <vxe-column field="buyChannelName" title="购买渠道" width="120"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="150"></vxe-column>
          <vxe-column field="stat" title="工单状态" width="120"></vxe-column>
          <vxe-column field="userName" title="消费者" width="120"></vxe-column>
          <vxe-column field="userProvice" title="消费者-省份" width="120"></vxe-column>
          <vxe-column field="userCity" title="消费者-城市" width="120"></vxe-column>
          <vxe-column field="userCounty" title="消费者-区县" width="120"></vxe-column>
          <vxe-column field="userTown" title="消费者-街道" width="120"></vxe-column>
          <vxe-column field="engineerName" title="工程师姓名" width="120"></vxe-column>
          <vxe-column field="finishTime" title="完工时间" width="150"></vxe-column>
          <vxe-column field="brandName" title="品牌" width="90"></vxe-column>
          <vxe-column field="serverTypeName" title="服务类型" width="120"></vxe-column>
          <vxe-column field="siteFinalAmount" title="本单结算金额" width="120"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes"></pager>

      </div>

      <div v-show="selectTab === 'tab2'">
        <vxe-table border :stripe="true"
          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
          :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
          height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.sfCheckBillDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="billNo" title="考核单号" width="120"></vxe-column>
          <vxe-column field="orderNo" title="工单号" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
                 <span v-if="row.stat==1">制单</span>
                 <span v-else-if="row.stat==2">待确认</span>
                 <span v-else-if="row.stat==3">待申诉</span>
                 <span v-else-if="row.stat==5">已申诉</span>
                 <span v-else-if="row.stat==7">执行考核</span>
                 <span v-else-if="row.stat==9">已结算</span>
                 <span v-else-if="row.stat==19">取消执行</span>
                 <span v-else-if="row.stat==99">关闭</span>
            </template>
          </vxe-column>
          <vxe-column field="orgName" title="服务中心" width="90"></vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="checkSubjectName" title="考核类别" width="90"></vxe-column>
          <vxe-column field="standardAmount" title="考核金额" width="90"></vxe-column>
          <vxe-column field="adjustAmount" title="调整金额" width="90"></vxe-column>
          <vxe-column field="amount" title="合计金额" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="审批金额" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
          <vxe-column field="remark" title="备注" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <div v-show="selectTab === 'tab3'">
        <vxe-table border :sync-resize="selectTab" :stripe="true"
          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
          :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
          height="400" :column-config="{ resizable: true }" :data="formData.sfBatchSettleAdjustDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="adjustNo" title="调整单号" width="120"></vxe-column>
          <vxe-column field="adjustAmount" title="调整金额" width="90"></vxe-column>
          <vxe-column field="adjustReason" title="调整原因" width="90"></vxe-column>
          <vxe-column field="pic1" title="凭证1" width="90">
            <template #default="{row}">
              <el-image v-if="row.pic1 != null" :src="row.pic1" :preview-src-list="[row.pic1]"/>
            </template>
          </vxe-column>
          <vxe-column field="pic2" title="凭证2" width="90">
            <template #default="{row}">
              <el-image v-if="row.pic2 != null" :src="row.pic2" :preview-src-list="[row.pic2]"/>
            </template>
          </vxe-column>
          <vxe-column field="pic3" title="凭证3" width="90">
            <template #default="{row}">
              <el-image v-if="row.pic3 != null" :src="row.pic3" :preview-src-list="[row.pic3]"/>
            </template>
          </vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
        <!-- @changeTablePage="changeTablePage(page,3)" -->

      </div>

      <!-- 费用申请单 -->
      <div v-show="selectTab === 'tab4'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.wkFeeApplyDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="applyNo" title="申请单号" width="120"></vxe-column>
          <vxe-column field="orderNo" title="工单号" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
              <span v-if="row.stat==1">制单</span>
              <span v-else-if="row.stat==2">审核中</span>
              <span v-else-if="row.stat==5">已审核</span>
              <span v-else-if="row.stat==6">驳回</span>
              <span v-else-if="row.stat==9">已结算</span>
              <span v-else-if="row.stat==99">取消</span>
            </template>
          </vxe-column>
          <vxe-column field="orgName" title="服务中心" width="90"></vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="applyTypeName" title="申请类型" width="90"></vxe-column>
          <vxe-column field="feeTypeName" title="费用类型" width="90"></vxe-column>
          <vxe-column field="feeAttributeName" title="费用名称" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="审批金额" width="90"></vxe-column>
          <!-- <vxe-column field="checkBy" title="审核人" width="90"></vxe-column> -->
          <vxe-column field="checkTime" title="审核时间" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!-- 用户关怀明细 -->
      <div v-show="selectTab === 'tab5'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.careDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="careNo" title="关怀单号" width="120"></vxe-column>
          <vxe-column field="orderNo" title="工单号" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
              <span v-if="row.stat==1">制单</span>
              <span v-else-if="row.stat==2">审核中</span>
              <span v-else-if="row.stat==5">已审核</span>
              <span v-else-if="row.stat==6">驳回</span>
              <span v-else-if="row.stat==9">已结算</span>
              <span v-else-if="row.stat==99">取消</span>
            </template>
          </vxe-column>
          <vxe-column field="label" title="关怀类型" width="90"></vxe-column>
          <vxe-column field="giftOndoorFee" title="赠送上门费" width="90"></vxe-column>
          <vxe-column field="giftOtherFee" title="赠送其他费用" width="100"></vxe-column>
          <vxe-column field="hxAmount" title="核销金额" width="90"></vxe-column>
          <vxe-column field="checkBy" title="审核人" width="90"></vxe-column>
          <vxe-column field="checkTime" title="审核时间" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!-- 奖罚单 -->
      <div v-show="selectTab === 'tab6'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.wkRewardApplyDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="applyNo" title="奖罚单号" width="120"></vxe-column>
          <vxe-column field="orderNo" title="工单号" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
              <span v-if="row.stat==1">制单</span>
              <span v-else-if="row.stat==2">审核中</span>
              <span v-else-if="row.stat==5">已审核</span>
              <span v-else-if="row.stat==6">驳回</span>
              <span v-else-if="row.stat==9">已结算</span>
              <span v-else-if="row.stat==99">取消</span>
            </template>
          </vxe-column>
          <vxe-column field="orgName" title="服务中心" width="90"></vxe-column>
          <vxe-column field="rewardObject" title="奖惩对象" width="90">
            <template #default="{row}">
              <span v-if="row.rewardObject==1">服务商</span>
              <span v-else-if="row.rewardObject==2">工程师</span>
            </template>
          </vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="engineerName" title="师傅名称" width="90"></vxe-column>
          <vxe-column field="feeAttributeName" title="费用名称" width="90"></vxe-column>
          <vxe-column field="feeTypeName" title="费用类型" width="90"></vxe-column>
          <vxe-column field="applyTypeName" title="申请类型" width="90"></vxe-column>
          <vxe-column field="applyAmount" title="申请金额" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="结算金额" width="90"></vxe-column>
          <!-- <vxe-column field="checkBy" title="审核人" width="90"></vxe-column> -->
          <vxe-column field="checkDate" title="审核时间" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!--激励单明细-->
      <div v-show="selectTab === 'tab7'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.wkSaleRewardApplyDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="applyNo" title="申请单号" width="120"></vxe-column>
          <vxe-column field="designOrderNo" title="设计单号" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
              <span v-if="row.stat==1">制单</span>
              <span v-else-if="row.stat==2">审核中</span>
              <span v-else-if="row.stat==5">已审核</span>
              <span v-else-if="row.stat==6">驳回</span>
              <span v-else-if="row.stat==9">已结算</span>
            </template>
          </vxe-column>
          <vxe-column field="orgName" title="服务中心" width="90"></vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="审批金额" width="90"></vxe-column>
          <vxe-column field="checkDate" title="审核时间" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!--激励单调整明细-->
      <div v-show="selectTab === 'tab8'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.wkSaleRewardAdjustDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="applyNo" title="申请单号" width="120"></vxe-column>
          <vxe-column field="designOrderNo" title="设计单号" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
              <span v-if="row.stat==1">制单</span>
              <span v-else-if="row.stat==2">审核中</span>
              <span v-else-if="row.stat==5">已审核</span>
              <span v-else-if="row.stat==6">驳回</span>
              <span v-else-if="row.stat==9">已结算</span>
            </template>
          </vxe-column>
          <vxe-column field="orgName" title="服务中心" width="90"></vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="审批金额" width="90"></vxe-column>
          <vxe-column field="checkDate" title="审核时间" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!--权益核销费用明细-->
      <div v-show="selectTab === 'tab9'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.rightsOffBillDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="billNo" title="核销单号" width="120"></vxe-column>
          <vxe-column field="rightsName" title="权益名称" width="120"></vxe-column>
          <vxe-column field="stat" title="状态" width="90">
            <template #default="{row}">
              <span v-if="row.stat==1">生成</span>
              <span v-else-if="row.stat==5">待结算</span>
              <span v-else-if="row.stat==9">已结算</span>
              <span v-else-if="row.stat==99">取消</span>
            </template>
          </vxe-column>
          <vxe-column field="orgName" title="服务中心" width="90"></vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="amount" title="金额" width="90"></vxe-column>
          <vxe-column field="settleFeeType" title="结算费用类型" width="90">
            <template #default="{row}">
              <span v-if="row.settleFeeType==1">安装</span>
              <span v-else-if="row.settleFeeType==2">维修</span>
              <span v-else-if="row.settleFeeType==9">其他</span>
            </template>
          </vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!--激励费用单明细-->
      <div v-show="selectTab === 'tab10'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.wkRewardFeeDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="rewardNo" title="奖励单号" width="120"></vxe-column>
          <vxe-column field="rewardTypeName" title="激励类型" width="90">
          </vxe-column>
          <vxe-column field="siteName" title="服务商名称" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="审批金额" width="90"></vxe-column>
          <vxe-column field="checkDate" title="审核时间" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="90"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" ></pager>
      </div>

      <!--奖惩费用单明细-->
      <div v-show="selectTab === 'tab11'">
        <vxe-table border :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }" show-overflow
                   height="400" :column-config="{ resizable: true }" :sync-resize="selectTab" :data="formData.wkPunishFeeDTOList">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="punishNo" title="奖惩单号" width="120"></vxe-column>
          <vxe-column field="punishType" title="奖惩类型" width="90">
            <template #default="{row}">
              <span v-if="row.punishType==1">星级奖励</span>
              <span v-else-if="row.punishType==2">区域奖励</span>
              <span v-else-if="row.punishType==3">翻倍奖励</span>
              <span v-else-if="row.punishType==4">好评奖励</span>
            </template>
          </vxe-column>
          <vxe-column field="orderNo" title="工单号" width="150"></vxe-column>
          <vxe-column field="barcode" title="条码" width="90"></vxe-column>
          <vxe-column field="bigCategoryName" title="产品大类" width="90"></vxe-column>
          <vxe-column field="smallCategoryName" title="产品小类" width="90"></vxe-column>
          <vxe-column field="itemCode" title="产品编码" width="90"></vxe-column>
          <vxe-column field="itemName" title="产品名称" width="90"></vxe-column>
          <vxe-column field="battleChannel" title="赛道" width="90"></vxe-column>
          <vxe-column field="stars" title="星级" width="90"></vxe-column>
          <vxe-column field="settleCoefficient" title="结算系数" width="90"></vxe-column>
          <vxe-column field="checkAmount" title="审批金额" width="90"></vxe-column>
          <vxe-column field="checkDate" title="审核时间" width="90"></vxe-column>
          <vxe-column field="settleNo" title="结算单号" width="90"></vxe-column>
          <vxe-column field="createBy" title="创建人" width="90"></vxe-column>
          <vxe-column field="createTime" title="创建时间" width="150"></vxe-column>
        </vxe-table>
        <pager style="position: relative;" ref="pager" :page-sizes="pageSizes" @changeTablePage="changePunishTablePage" ></pager>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" plain class="button-sty" @click="dialogClose">
          <i class="el-icon-close el-icon"></i>取 消 </el-button> -->
        <el-button type="primary" @click="dialogClose" class="button-sty">
          <i class="el-icon-check el-icon"></i>确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
import { initVxeTable } from '@/const/crud/admin/table'

export default {
  name: 'saleConfigDialog',
  props: ['id'],
  mixins: [selectDialogMixins],
  components: { pager },
  created() {
    console.log('获取结算ID---->', this.id)
    this.formData.id = this.id
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },

  mounted() {
    this.changeTableOrderDetails()
    this.changeTableDetails()
    this.changePunishTablePage()
    // this.changeTablePage()
  },

  computed: {},

  data() {
    return {
      total: 0,
      pageSizes: [50, 100, 500],
      // requestParam: {
      //   searchCount: false,  // 是否分页
      //   current: 1,  // 当前页面
      //   size: 0,  // 页面数据量

      // },
      selectTab: 'tab1',
      tableData: [],
      // areaValues: [],
      // areaProps: {
      //   lazy: true,
      //   checkStrictly: true,
      //   lazyLoad: this.cascaderLazyLoad
      // },
      area: {
        country: null,
        province: null,
        city: null,
        county: null,
        town: null,
      },
      requestPunishParam: {

      },
      // areaOption: [],
      // dataId: 0,
      formData: {
        id: null,
        soOrderDTOList:[],
        sfCheckBillDTOList:[],
        sfBatchSettleAdjustDTOList:[],
        wkFeeApplyDTOList: [],
        wkSaleRewardAdjustDTOList:[],
        wkSaleRewardApplyDTOList:[],
        rightsOffBillDTOList:[],
        wkRewardFeeDTOList:[],
        wkPunishFeeDTOList:[],

        // isNew: true
      },
      // showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      // selectMulti: true,
      // addressTypeOption: [],

    };
  },


  methods: {
    changePunishTablePage(){
      this.requestPunishParam.size = page.pageSize
      this.requestPunishParam.current = page.currentPage
      this.requestPunishParam.searchCount = flag
      if (selectTab == 'tab11'){
        var data = {
          label:'tab11'
        }
        this.changeTableDetails(data)
      }

    },
    //默认查询工单数据
    changeTableOrderDetails() {
      // console.log(data,'hhhhhhh')
      this.$http({
        url: api.sfBatchSettle.getPageOrderDataUrl,
        method: 'post',
        data: this.formData
      }).then(response => {
          console.log(response.data.data, '工单查询明细数据----')
          if (response.data.data != null) {
            this.formData.soOrderDTOList = response.data.data
            console.log(this.formData.soOrderDTOList);
          }
      })
    },

    changeTableDetails(data) {
      // console.log(data,'hhhhhhh')
      let type = data.label;
      var paths = null
      if(type==='tab1'){
        paths = api.sfBatchSettle.getPageOrderDataUrl
      }else if(type==='tab2'){
        paths = api.sfBatchSettle.getPageCheckDataUrl
      }else if(type==='tab3'){
        paths = api.sfBatchSettle.getPageAdjustDataUrl
      }else if(type==='tab4'){
        paths = api.sfBatchSettle.getPageApplyDataUrl
      }else if(type==='tab7'){
        paths = api.sfBatchSettle.getPageWkSaleRewardApplyDataUrl
      }else if(type==='tab8'){
        paths = api.sfBatchSettle.getPageSaleRewardAjustDataUrl
      }else if(type==='tab9'){
        paths = api.sfBatchSettle.getPageRightsOffBillDataUrl
      }else if(type==='tab10'){
        paths = api.sfBatchSettle.getPageWkRewardFeeDataUrl
      }else if(type==='tab11'){
        paths = api.sfBatchSettle.getPageWkPunishFeeDataUrl
        this.formData.size =  this.requestPunishParam.size
        this.formData.current =  this.requestPunishParam.current
        this.formData.searchCount =  this.requestPunishParam.searchCount
      }

      this.$http({
        url: paths,
        method: 'post',
        data: this.formData
      }).then(response => {
        if(type==='tab1'){
          console.log(response.data.data, '工单查询明细数据')
          if (response.data.data != null) {
            this.formData.soOrderDTOList = response.data.data
            console.log(this.formData.soOrderDTOList);
          }
        }else if(type==='tab2'){
          console.log(response.data.data, '考核单查询明细数据')
          if (response.data.data != null) {
            this.formData.sfCheckBillDTOList = response.data.data
          }
        }else if(type==='tab3'){
          console.log(response.data.data, '调整单查询明细数据')
          if (response.data.data != null) {
            this.formData.sfBatchSettleAdjustDTOList = response.data.data
          }
        }else if(type==='tab4'){
          console.log(response.data.data, '费用申请明细数据')
          this.formData.wkFeeApplyDTOList = response.data.data
        }else if(type==='tab7'){
          console.log(response.data.data, '销售单激励明细数据')
          this.formData.wkSaleRewardApplyDTOList = response.data.data
        }else if(type==='tab8'){
          console.log(response.data.data, '销售单调整明细数据')
          this.formData.wkSaleRewardAdjustDTOList = response.data.data
        }else if(type==='tab9'){
          console.log(response.data.data, '权益核销单明细数据')
          this.formData.rightsOffBillDTOList = response.data.data
        }else if(type==='tab10'){
          console.log(response.data.data, '激励费用单明细数据')
          this.formData.wkRewardFeeDTOList = response.data.data
        }else if(type==='tab11'){
          console.log(response.data.data, '奖惩费用单明细数据')
          this.formData.wkPunishFeeDTOList = response.data.data.records
        }
      })
    },

    // changeTablePage(flag) {
    //   console.log('执行查询-----');
    //   var paths = null
    //   if(flag=1){
    //     paths = api.sfBatchSettle.getPageOrderDataUrl
    //   }else if(flag=2){
    //     paths = api.sfBatchSettle.getPageCheckDataUrl
    //   }else if(flag=3){
    //     paths = api.sfBatchSettle.getPageAdjustDataUrl
    //   }
    //   this.$http({
    //     url: paths,
    //     method: 'post',
    //     data: this.formData
    //   }).then(response => {
    //     if (response.data.data != null) {
    //         this.formData.soOrderDTOList = response.data.data
    //         console.log(this.formData.soOrderDTOList);
    //       }
    //   })
    // },

    // changeTablePage() {
    //   console.log('执行查询-----');
    //   this.$http({
    //     url: api.sfBatchSettle.getPageOrderDataUrl,
    //     method: 'post',
    //     data: this.formData
    //   }).then(response => {
    //     console.log(response.data.data, '工单查询明细数据')
    //       if (response.data.data != null) {
    //         this.formData.soOrderDTOList = response.data.data
    //         console.log(this.formData.soOrderDTOList);
    //       }
    //   })
    // },

  }
};
</script>
<style lang="scss" scoped>
 ::v-deep .el-dialog {
    overflow: hidden;
    margin-top: 15vh!important;
}
.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-pager {
  display: inline-block;
  width: 50%;
  position: fixed;
  bottom: -65px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
  text-align: left;
}
</style>

